jQuery(document).ready(function( $ ){
    
    $( ".informational-arrow" ).on( "click", function(){

        $( this ).prev( '.description-hidden' ).slideToggle();
        var expanded       = $( this ).data( "expanded" );
        var expansion_text = expanded ? 'Read More' : 'Read Less';
        $( this ).find( '.toggle-expansion-text' ).html( expansion_text );
        $( this ).data( "expanded", !expanded );
        $( this ).find( '.toggle-expansion-arrow' ).toggleClass( 'up-arrow-image down-arrow-image');

    });

});
